/* kh-katalog.js — Filter, Suche und Sortierung der Artikeltabelle.
   Läuft komplett im Browser: alle Artikel stehen in einer Tabelle.
   Shopify rendert davon höchstens 250 je Seite; hat die Kollektion mehr,
   holt nachladen() die Seiten 2 ff. über die Section Rendering API und
   hängt ihre Zeilen an. Danach filtert und sortiert alles wie vorher.

   Dieselbe Datei treibt die Einzeldosen-Kacheln (kh-einzeldosen): dort sind
   die [data-kh-zeile] Kacheln statt Tabellenzeilen, die data-Attribute
   dieselben.

   Vorgabe 23.09.2026:
   - Ausverkauft heisst unsichtbar. Zeilen mit data-lager="0" stehen nur da,
     wenn „Auch nicht lieferbare" (data-kh-filter="alle") an ist.
   - Eigene Artikel vor NYE-Artikeln (data-eigen="1" vor "0"), auch ueber die
     nachgeladenen Seiten hinweg. */
(function () {
  'use strict';
  var leiste = document.querySelector('[data-kh-katalog-leiste]');
  var tbody = document.querySelector('[data-kh-zeilen]');
  if (!leiste || !tbody) return;

  var zeilen = [];
  function zeilenLesen() {
    zeilen = Array.prototype.slice.call(tbody.querySelectorAll('[data-kh-zeile]'));
    zeilen.forEach(function (z, i) { z.dataset.reihenfolge = i; });
  }
  zeilenLesen();
  var suche = leiste.querySelector('[data-kh-suche]');
  var sort = leiste.querySelector('[data-kh-sort]');
  var anzahl = leiste.querySelector('[data-kh-anzahl]');
  var leer = document.querySelector('[data-kh-leer]');
  var resets = document.querySelectorAll('[data-kh-reset]');
  var resetKnopf = leiste.querySelector('[data-kh-reset]');

  function aktiveFilter() {
    var f = {};
    leiste.querySelectorAll('[data-kh-filter]:checked').forEach(function (cb) {
      var k = cb.dataset.khFilter;
      (f[k] = f[k] || []).push(cb.value);
    });
    return f;
  }

  function passt(z, f, q) {
    if (f.marke && f.marke.indexOf(z.dataset.marke) < 0) return false;
    if (f.kategorie && f.kategorie.indexOf(z.dataset.kategorie) < 0) return false;
    if (f.staerke && f.staerke.indexOf(z.dataset.staerke) < 0) return false;
    if (f.format && f.format.indexOf(z.dataset.format) < 0) return false;
    if (!f.alle && z.dataset.lager !== '1') return false;
    if (q && (z.dataset.suche || '').indexOf(q) < 0) return false;
    return true;
  }

  function zaehlen(f, q) {
    /* Zahl je Option: wie viele Zeilen blieben, wenn nur diese Option
       zusätzlich gewählt wäre -- mit den Filtern der anderen Gruppen. */
    leiste.querySelectorAll('[data-kh-filter]').forEach(function (cb) {
      var k = cb.dataset.khFilter, ziel = cb.parentElement.querySelector('[data-kh-zahl]');
      if (!ziel) return;
      var f2 = {}; Object.keys(f).forEach(function (kk) { if (kk !== k) f2[kk] = f[kk]; });
      f2[k] = [cb.value];
      var n = zeilen.filter(function (z) { return passt(z, f2, q); }).length;
      ziel.textContent = n;
      cb.disabled = n === 0 && !cb.checked;
    });
    leiste.querySelectorAll('[data-kh-gruppe]').forEach(function (d) {
      var n = d.querySelectorAll('[data-kh-filter]:checked').length;
      var b = d.querySelector('.kh-kat__gruppe-zahl');
      if (b) { b.textContent = n; b.hidden = n === 0; }
      d.dataset.aktiv = n ? '1' : '0';
    });
  }

  function eigen(z) { return z.dataset.eigen === '0' ? 0 : 1; }

  function sortieren() {
    var art = sort ? sort.value : 'standard';
    var s = zeilen.slice();
    var cmp = {
      standard: function (a, b) { return eigen(b) - eigen(a) || a.dataset.reihenfolge - b.dataset.reihenfolge; },
      name: function (a, b) { return a.dataset.name.localeCompare(b.dataset.name, 'de'); },
      marke: function (a, b) { return a.dataset.marke.localeCompare(b.dataset.marke, 'de') || a.dataset.name.localeCompare(b.dataset.name, 'de'); },
      'preis-auf': function (a, b) { return a.dataset.preis - b.dataset.preis; },
      'preis-ab': function (a, b) { return b.dataset.preis - a.dataset.preis; },
      lager: function (a, b) { return (b.dataset.lager - a.dataset.lager) || (a.dataset.reihenfolge - b.dataset.reihenfolge); }
    }[art] || function () { return 0; };
    s.sort(cmp).forEach(function (z) { tbody.appendChild(z); });
  }

  function anwenden() {
    var f = aktiveFilter();
    var q = (suche && suche.value || '').trim().toLowerCase();
    var n = 0;
    zeilen.forEach(function (z) {
      var ok = passt(z, f, q);
      z.hidden = !ok;
      if (ok) n++;
    });
    if (anzahl) anzahl.textContent = n;
    if (leer) leer.hidden = n > 0;
    var aktiv = Object.keys(f).length > 0 || q.length > 0;
    if (resetKnopf) resetKnopf.dataset.sichtbar = aktiv ? '1' : '0';
    zaehlen(f, q);
  }

  leiste.addEventListener('change', function (e) {
    if (e.target.matches('[data-kh-filter]')) anwenden();
    if (e.target === sort) sortieren();
  });
  if (suche) {
    var t; suche.addEventListener('input', function () { clearTimeout(t); t = setTimeout(anwenden, 120); });
  }
  resets.forEach(function (r) {
    r.addEventListener('click', function () {
      leiste.querySelectorAll('[data-kh-filter]').forEach(function (cb) { cb.checked = false; });
      if (suche) suche.value = '';
      anwenden();
    });
  });

  /* Aufgeklappte Gruppen schließen, wenn daneben geklickt wird */
  document.addEventListener('click', function (e) {
    leiste.querySelectorAll('details[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.open = false;
    });
  });

  /* Filter-Kästchen für Werte, die erst auf Seite 2 ff. vorkommen. Die
     Liquid-Seite kennt nur die ersten 250 Artikel -- eine Marke, die dort
     fehlt, hätte sonst kein Kästchen und wäre nicht filterbar. */
  function optionenErgaenzen() {
    ['marke', 'staerke', 'format'].forEach(function (k) {
      var panel = leiste.querySelector('[data-kh-gruppe="' + k + '"] .kh-kat__panel');
      if (!panel) return;
      var da = {};
      panel.querySelectorAll('[data-kh-filter]').forEach(function (cb) { da[cb.value] = true; });
      var neu = false;
      zeilen.forEach(function (z) {
        var wert = z.dataset[k], name = z.dataset[k + 'Name'];
        if (!wert || !name || da[wert]) return;
        da[wert] = true; neu = true;
        var label = document.createElement('label');
        label.className = 'kh-kat__option';
        var cb = document.createElement('input');
        cb.type = 'checkbox'; cb.value = wert; cb.dataset.khFilter = k;
        var zahl = document.createElement('span');
        zahl.setAttribute('data-kh-zahl', '');
        label.appendChild(cb);
        label.appendChild(document.createTextNode(' ' + name + ' '));
        label.appendChild(zahl);
        panel.appendChild(label);
      });
      if (!neu) return;
      Array.prototype.slice.call(panel.children)
        .sort(function (a, b) { return a.textContent.trim().localeCompare(b.textContent.trim(), 'de'); })
        .forEach(function (el) { panel.appendChild(el); });
    });
  }

  /* Die Adresse behaelt ihre Parameter: ?view=einzeldosen waehlt die
     Vorlage, ohne ihn kaemen die Zeilen der Tabelle statt der Kacheln. */
  function seitenAdresse(seite, sektion) {
    var u = new URL(location.href);
    u.hash = '';
    u.searchParams.set('page', seite);
    u.searchParams.set('section_id', sektion);
    return u.pathname + u.search;
  }

  function nachladen() {
    var tabelle = tbody.closest('[data-kh-tabelle]');
    var seiten = parseInt(tabelle && tabelle.dataset.khSeiten, 10) || 1;
    var laedt = leiste.querySelector('[data-kh-laedt]');
    if (seiten < 2) return;
    var abrufe = [];
    for (var s = 2; s <= seiten; s++) {
      abrufe.push(
        fetch(seitenAdresse(s, tabelle.dataset.khSection))
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; })
      );
    }
    /* Promise.all hält die Reihenfolge der Seiten, egal welche zuerst antwortet */
    Promise.all(abrufe).then(function (htmls) {
      var fehlt = false;
      htmls.forEach(function (html) {
        if (!html) { fehlt = true; return; }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('[data-kh-zeilen] [data-kh-zeile]').forEach(function (z) {
          tbody.appendChild(document.importNode(z, true));
        });
      });
      zeilenLesen();
      optionenErgaenzen();
      vorwaehlen();
      if (window.KH && KH.stepperBinden) KH.stepperBinden(tbody);
      /* Immer sortieren, auch bei „Sortierung": Seite 2 bringt eigene
         Artikel mit, die sonst hinter den NYE-Artikeln von Seite 1 stuenden. */
      sortieren();
      anwenden();
      if (laedt) {
        if (fehlt) laedt.textContent = ' · nicht alle Artikel geladen, Seite neu laden';
        else laedt.hidden = true;
      }
    });
  }

  /* Vorauswahl aus der Adresse: ?staerke=strong, ?portion=slim, ?marke=velo
     (mehrere mit Komma). Format heisst in der Adresse „portion": ?format=
     ist bei Shopify reserviert und liefert live 404 (gemessen 23.09.2026). So verlinkt das breite Menue im Kopf direkt auf
     „Nicotine Pouches, stark". Werte ohne passendes Kaestchen werden
     ignoriert -- dann steht die ganze Liste da, nicht eine leere. Nach dem
     Nachladen noch einmal, weil erst dann alle Kaestchen existieren. */
  var vorwahl = {};
  try {
    var ps = new URLSearchParams(location.search);
    var namen = { marke: 'marke', kategorie: 'kategorie', staerke: 'staerke', portion: 'format' };
    Object.keys(namen).forEach(function (param) {
      var k = namen[param], v = ps.get(param);
      if (v) vorwahl[k] = v.toLowerCase().split(',').map(function (s) { return s.trim(); });
    });
    /* Wer ausdruecklich nach Verfuegbarkeit filtert, will auch die
       ausverkauften sehen koennen. */
    if (ps.has('filter.v.availability')) vorwahl.alle = ['1'];
  } catch (e) {}
  function vorwaehlen() {
    Object.keys(vorwahl).forEach(function (k) {
      leiste.querySelectorAll('[data-kh-filter="' + k + '"]').forEach(function (cb) {
        if (vorwahl[k].indexOf(cb.value) >= 0) cb.checked = true;
      });
    });
  }

  vorwaehlen();
  anwenden();
  nachladen();
})();
